import graphql__c6cb7f0ce92019e93a1b from "./__generated__/TransferAppDestinationSelectorFragment_organization.graphql.ts";
import graphql__3e834c743986958a4739 from "./__generated__/TransferAppDestinationSelectorQuery.graphql.ts";/* eslint-disable relay/unused-fields */
import { RadioButtonList } from '@portal/components'
import { graphql } from 'babel-plugin-relay/macro'
import { upperFirst } from 'lodash'
import React, { useState } from 'react'
import { readInlineData } from 'react-relay'
import { useLazyLoadQuery } from 'react-relay/hooks'

import { TransferAppDestinationSelectorFragment_organization$key } from './__generated__/TransferAppDestinationSelectorFragment_organization.graphql'
import { TransferAppDestinationSelectorQuery } from './__generated__/TransferAppDestinationSelectorQuery.graphql'
import AppOrganizationSelectDestinationInput from './AppOrganizationSelectDestinationInput'
import AppOrganizationSlugDestinationInput from './AppOrganizationSlugDestinationInput'
import AppUserDestinationInput from './AppUserDestinationInput'

const transferOptions = {
  user: 'The user must already have a Ditto portal account',
  organization: 'You must be a member of the receiving organization',
}

export type TransferTypeOption = keyof typeof transferOptions

const organizationFragment = graphql__c6cb7f0ce92019e93a1b

const query = graphql__3e834c743986958a4739

type Props = {
  appId: string
}

/** Component used for selecting a target destination for an app. Allows to insert a user or
 * organization and to create an app transfer request to that destination.
 */
const TransferAppDestinationSelector: React.FC<Props> = ({ appId }) => {
  const [transferTo, setTransferTo] = useState<TransferTypeOption>('user')
  const { viewer } = useLazyLoadQuery<TransferAppDestinationSelectorQuery>(
    query,
    {
      appId,
    },
    { fetchPolicy: 'store-and-network' },
  )

  // If the current app belongs to an organization the user must belong to at least one other organization
  // in order to pick an organization as a destination. If the tenant is a user, it's enough for the current
  // viewer to belong to just a single organization.
  const destinationOrganizationsExist =
    viewer.appById?.tenant.__typename === 'Organization'
      ? (viewer.me?.organizations || []).length > 1
      : (viewer.me?.organizations || []).length > 0

  const isSuperAdmin = viewer.me?.isSuperAdmin

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTransferTo(event.target.value as TransferTypeOption)
  }

  return (
    <div className="mt-4 max-w-xl">
      <RadioButtonList<TransferTypeOption>
        value={transferTo}
        options={['user', 'organization']}
        keyFn={(option) => option}
        renderFn={(transferType) => ({
          title: upperFirst(transferType),
          description: transferOptions[transferType],
        })}
        disabled={
          !destinationOrganizationsExist && !isSuperAdmin
            ? ['organization']
            : []
        }
        onChange={handleInputChange}
        htmlFor="type"
        className="mb-8"
      />
      {transferTo === 'user' && <AppUserDestinationInput appId={appId} />}
      {transferTo === 'organization' &&
        (isSuperAdmin ? (
          <AppOrganizationSlugDestinationInput appId={appId} />
        ) : (
          <AppOrganizationSelectDestinationInput
            appId={appId}
            organizations={(viewer.me?.organizations || []).map(
              (personalOrganizationKey) =>
                readInlineData<TransferAppDestinationSelectorFragment_organization$key>(
                  organizationFragment,
                  personalOrganizationKey,
                ),
            )}
          />
        ))}
    </div>
  )
}

export default TransferAppDestinationSelector
